import { createFileRoute } from "@tanstack/react-router"

import { ServiceRequestForm } from "@/components/forms/service-request-form"
import { Header } from "@/components/header"

export const Route = createFileRoute(
  "/_home/manage-consumers/add-service-request",
)({
  component: AddServiceRequest,
})

function AddServiceRequest() {
  return (
    <main className="space-y-4 p-4">
      <Header
        subroutes={[
          {
            route: "/manage-consumers",
            label: "Manage Consumers",
          },
        ]}
      >
        Create Service Request
      </Header>

      <ServiceRequestForm />
    </main>
  )
}
